import React, { forwardRef } from 'react';
import ReportPaper from './ReportPaper';
import styles from './FullReportTemplate.module.css';
import { classificationOf } from '../../../pages/appointment/modules/diagnoses/diagnoses';

/**
 * Relatório completo do atendimento (ou do paciente): um único papel com a
 * capa (clínica, paciente, profissional, título, os diagnósticos do
 * atendimento e a lista do que está incluído) e, em seguida, uma seção por módulo, cada uma começando em página
 * nova com o título do módulo e o mesmo miolo do PDF individual. A assinatura
 * sai uma única vez, no fim.
 *
 * `sections`: [{ key, title, subtitle, Body, job }] já preparados
 * (prepareFullReport); `diagnoses`: diagnósticos deste atendimento (vazio na
 * aba Saúde).
 */
const FullReportTemplate = forwardRef(({ companyData, professional, patientName, title, subtitle, date, sections, diagnoses }, ref) => {
  const list = Array.isArray(sections) ? sections : [];
  const cids = Array.isArray(diagnoses) ? diagnoses : [];

  return (
    <ReportPaper
      ref={ref}
      companyData={companyData}
      professional={professional}
      patientName={patientName}
      title={title}
      subtitle={subtitle}
      date={date}
    >
      {cids.length > 0 && (
        <div className={styles.contents}>
          <span className={styles.contentsTitle}>Diagnósticos deste atendimento</span>
          <ul className={styles.contentsList}>
            {cids.map((diagnosis) => (
              <li key={diagnosis.id}>
                <strong>{diagnosis.code}</strong> {diagnosis.title} ({classificationOf(diagnosis).label})
              </li>
            ))}
          </ul>
        </div>
      )}

      <div className={styles.contents}>
        <span className={styles.contentsTitle}>Conteúdo</span>
        <ol className={styles.contentsList}>
          {list.map((section) => <li key={section.key}>{section.title}</li>)}
        </ol>
      </div>

      {list.map((section) => {
        const Body = section.Body;
        return (
          <div key={section.key} className={styles.section}>
            <div className={styles.sectionHead}>
              <h3 className={styles.sectionTitle}>{section.title}</h3>
              {section.subtitle && <span className={styles.sectionSubtitle}>{section.subtitle}</span>}
            </div>
            <Body {...section.job} />
          </div>
        );
      })}
    </ReportPaper>
  );
});

FullReportTemplate.displayName = 'FullReportTemplate';

export default FullReportTemplate;
